import { render, staticRenderFns } from "./stats.products.vue?vue&type=template&id=b05a6e94&scoped=true&"
import script from "./stats.products.vue?vue&type=script&lang=js&"
export * from "./stats.products.vue?vue&type=script&lang=js&"
import style0 from "./stats.products.vue?vue&type=style&index=0&id=b05a6e94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b05a6e94",
  null
  
)

export default component.exports